import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ApiService, LanguagesService, MessageService} from '../../../core';
import {ServiceCode} from '../../../core';

@Component({
  selector: 'gc-import-button',
  templateUrl: './import-button.component.html',
  styleUrls: ['./import-button.component.less']
})
export class ImportButtonComponent implements OnInit {

  constructor(private message: MessageService, private api: ApiService,
              public lang: LanguagesService) { }

  dialogVisible = false;
  private file = null;

  @Input()
  apiUrl: string = null;

  @Input()
  define: any = null;

  @Input()
  note: string = null;

  @Output()
  imported: EventEmitter<void> = new EventEmitter<void>();

  @Input()
  caption: string = null;

  @Input()
  primary = false;

  ngOnInit(): void {

  }

  onFileChange(event): void {
    if (event.target.files && event.target.files.length) {
      this.file = event.target.files[0];
    } else {
      this.file = null;
    }
  }

  upload(): void {
    if (!this.define || !this.apiUrl) {
      return;
    }

    if (!this.file) {
      this.message.error(this.lang.define.lib.selectFileImportMessage);
      return;
    }

    this.api.import(this.apiUrl, {file: this.file, note: 'Ghi chú tí chơi thôi'},  ((code, message, _) => {
      if ( code !== ServiceCode.Success) {
        this.message.error(message);
      }else{
        this.close();
        this.message.success(this.lang.define.lib.importSuccessMessage);
        if (this.imported) {
          this.imported.emit();
        }
      }
    }));
  }

  download(): void {
    if (!this.define || !this.apiUrl) {
      return;
    }
    this.api.sample(this.apiUrl, this.define, {}, ((code, message) => {
      if (code !== ServiceCode.Success) {
        this.message.error(message);
      }else{
        // this.close();
      }
    }));
  }

  close(): void {
    this.dialogVisible = false;
    this.file = null;
  }
}
